import gql from "graphql-tag";

export const uploadDocumentMutation = gql`
  mutation UploadDocument($id: String, $file: Upload!, $projectId: String!) {
    document: UploadDocument(id: $id, file: $file, projectId: $projectId) {
      id
    }
  }
`;
